import { useEffect } from 'react';

import { syncPush } from '@/lib/push';
import { canHavePush } from '@/lib/pushAccess';
import { useAuthStore } from '@/stores/auth';

/**
 * Пуши для вошедшего ученика: разрешение (один раз) и метка устройства (каждый запуск).
 *
 * Живёт в оболочке, а не в хранилище входа: оболочка появляется и после входа, и при запуске с живой
 * сессией (обновившиеся с 1.1.0 входа не проходят), и только когда сессия уже прочитана. Набор разделов
 * приходит с `/auth/me` чуть позже входа — поэтому слушаем и его: стал учеником с куратором — спросим.
 *
 * На сайте, у бесплатника и у сотрудника `syncPush` выходит сразу (`lib/push.ts`, `lib/pushAccess.ts`).
 */
export function usePushSync(): void {
  const user = useAuthStore((s) => s.user);
  const userId = user?.id;
  const allowed = canHavePush(user);

  useEffect(() => {
    if (!userId || !allowed) return;
    void syncPush(useAuthStore.getState().user);
  }, [userId, allowed]);
}
